// Module
var code = "<garp-configuration></garp-configuration>\n";
// Exports
module.exports = code;